import { Stack, Typography } from "@mui/material";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

export default function EmptyTable() {
  return (
    <Stack spacing="8px" alignItems="center" sx={{ pt: "50px", pb: "50px" }}>
      <InboxOutlinedIcon
        sx={{
          color: "#00000061",
          height: "48px",
          width: "48px",
        }}
      />
      <Typography
        sx={{
          color: "#000000DE",
          fontSize: "16px",
          fontWeight: 600,
          fontFamily: "Roboto",
          textAlign: "center",
        }}
      >
        No hay datos disponibles
      </Typography>
      <Typography
        sx={{
          color: "#00000099",
          fontSize: "14px",
          fontWeight: 400,
          fontFamily: "Roboto",
          textAlign: "center",
        }}
      >
        Todavía no existen registros para mostrar.
      </Typography>
    </Stack>
  );
}
